import { render, staticRenderFns } from "./TableCalculations.vue?vue&type=template&id=acfd9aae&scoped=true&"
import script from "./TableCalculations.vue?vue&type=script&lang=ts&"
export * from "./TableCalculations.vue?vue&type=script&lang=ts&"
import style0 from "./TableCalculations.vue?vue&type=style&index=0&id=acfd9aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfd9aae",
  null
  
)

export default component.exports